// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
import type { ViewContext } from '../viewContext';
import type { ViewId } from '../types';
import { buildInsights } from '../analysis';
import { escapeHtml } from '../utils/format';

const VIEW_LABEL: Record<string, string> = {
  map: 'the map',
  time: 'the timeline',
  species: 'species',
  activities: 'activities',
  seasonality: 'seasons',
  explorer: 'the explorer',
};

export function renderInsights(root: HTMLElement, ctx: ViewContext): void {
  const insights = buildInsights(ctx.data.incidents, ctx.data.meta.dataThrough);

  root.innerHTML = `
    <div class="view-head">
      <h1 class="view-title">What the data says</h1>
      <p class="view-sub">Patterns the numbers surface on their own — read them as context, not advice. Each links to the view it came from.</p>
    </div>
    <div class="insight-grid">
      ${insights
        .map(
          (ins) => `<div class="insight ${ins.severity}">
            <h3>${escapeHtml(ins.title)}</h3>
            <p>${escapeHtml(ins.body)}</p>
            ${ins.view ? `<div class="insight-links"><button class="chip" data-goto="${escapeHtml(ins.view)}">See ${VIEW_LABEL[ins.view] ?? ins.view} →</button></div>` : ''}
          </div>`,
        )
        .join('')}
    </div>
  `;

  root.querySelectorAll('[data-goto]').forEach((b) => b.addEventListener('click', () => ctx.goTo(b.getAttribute('data-goto') as ViewId)));
}
